import type {ScanDisplayInfo} from "../scan-model/ScanContext.tsx";
import {ScanningLog} from "./ScanningLog.tsx";

export function ScanningDisplay({ display }: { display: ScanDisplayInfo }) {
    return <div>
        <h2>Scanning...</h2>
        <ScanningLog messages={display.loggedMessages} />
        <div>
            {display.activeActions.map((action, index) => <div key={index}>
                {action.action} - {action.completed}/{action.total}
            </div>)}
        </div>
    </div>

}